/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResellerCollectionResponse } from '../../models/reseller-collection-response';

export interface GetResellers$Params {
}

export function getResellers(http: HttpClient, rootUrl: string, params?: GetResellers$Params, context?: HttpContext): Observable<StrictHttpResponse<ResellerCollectionResponse>> {
  const rb = new RequestBuilder(rootUrl, getResellers.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResellerCollectionResponse>;
    })
  );
}

getResellers.PATH = '/resellers';
